import { defineStore } from 'pinia';
import { fetchWrapper } from '@/helpers';
import { useAlertStore } from '@/stores';
import apiStore from './api.store';

export const useCmsVideoStore = defineStore({
    id: 'cms',
    state: () => ({
        videos: {},
        video: {},
        totalData: 0,
        totalAllData: 0,
    }),
    actions: {
        async fetchCmsVideos(search = null, page = 1, limit = 1, order = ['createdAt', 'desc']) {
            this.videos = { loading: true };
            this.totalData = 0;
            this.totalAllData = 0;
            const options = {
                url: apiStore.cms.videos,
                params: {
                    order: order[0],
                    sort: order[1],
                    search: search || null,
                    page,
                    limit,
                    appSource: 'dokumen',
                }
            };
            try {
                const result = await fetchWrapper.get(options);   
                this.totalData = result.totalData;
                this.totalAllData = result.totalAllData;
                this.videos = result.data;
            } catch (error) {
                this.videos = { error };
            }
        },
        async fetchCmsVideo(slug) {
            this.video = { loading: true };
            const newUrl = apiStore.cms.video.replace(":slug", `${slug}`);
            const options = {
                url: newUrl,
            };
            try {
                const fetchCmsVideoResult = await fetchWrapper.get(options);    
                this.video = fetchCmsVideoResult.data;
            } catch (error) {
                this.video = { error };
            }
        },
        async createCmsVideo(payload) {
            const alertStore = useAlertStore();
            const options = {
                url: apiStore.cms.videoCreate,
                body: { ...payload, appSource: 'dokumen' },
            };
            try {
                await fetchWrapper.post(options);
                alertStore.success();  
            } catch (error) {
                alertStore.error(error);
                throw error;
            }
        },
        async updateCmsVideo(slug, payload) {
            const alertStore = useAlertStore();
            const newUrl = apiStore.cms.videoPatch.replace(":slug", `${slug}`);
            if (payload.featuredImage instanceof File === false) delete payload.featuredImage;
            const options = {
                url: newUrl,
                body: { ...payload, appSource: 'dokumen' },
            };
            try {
                await fetchWrapper.patch(options); 
                alertStore.success();  
            } catch (error) {
                alertStore.error(error);
                throw error;
            }
        },
    }
});
